module.exports = __webpack_public_path__ + "static/cloud-blue-01aa430e11940612ab65d6caff505705.png";